var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperationSearchingList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 21.875L15.625 15.625M3.125 10.4167C3.125 11.3742 3.3136 12.3224 3.68005 13.2071C4.04649 14.0917 4.58359 14.8956 5.26068 15.5727C5.93777 16.2497 6.7416 16.7868 7.62627 17.1533C8.51093 17.5197 9.45911 17.7083 10.4167 17.7083C11.3742 17.7083 12.3224 17.5197 13.2071 17.1533C14.0917 16.7868 14.8956 16.2497 15.5727 15.5727C16.2497 14.8956 16.7868 14.0917 17.1533 13.2071C17.5197 12.3224 17.7083 11.3742 17.7083 10.4167C17.7083 9.45911 17.5197 8.51093 17.1533 7.62627C16.7868 6.7416 16.2497 5.93777 15.5727 5.26068C14.8956 4.58359 14.0917 4.04649 13.2071 3.68004C12.3224 3.3136 11.3742 3.125 10.4167 3.125C9.45911 3.125 8.51093 3.3136 7.62627 3.68004C6.7416 4.04649 5.93777 4.58359 5.26068 5.26068C4.58359 5.93777 4.04649 6.7416 3.68005 7.62627C3.3136 8.51093 3.125 9.45911 3.125 10.4167Z",
    stroke: "#176318",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationSearchingList);
export default __webpack_public_path__ + "static/media/OperationSearchingList.810f638ee4901ec816f763872c583fa9.svg";
export { ForwardRef as ReactComponent };